import React from 'react';

const Card = (props) => {
  const isCurrent = props.year && (
    props.year.toLowerCase().includes('heden') ||
    props.year.toLowerCase().includes('present') ||
    props.year.toLowerCase().includes('presente') ||
    props.year.toLowerCase().includes('présent') ||
    props.year.includes('至今')
  );

  return (
    <div className={`timeline__item ${isCurrent ? 'timeline__item--current' : ''}`}>
      <i className={props.icon}></i>
      <span className="timeline__date">
        {isCurrent && <span className="timeline__pulse-dot" title="Huidige positie"></span>}
        {props.year}
      </span>
      <h3 className="timeline__title">{props.title}</h3>
      <p className="timeline__text">{props.desc}</p>
    </div>
  );
};

export default Card;